class GiftcardController {
    /*@ngInject*/
    constructor() {
        this.requestPending = false;
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default GiftcardController;
